const faqItems = [
  {
    q: '91影视看片app是否需要付费？',
    a: '91影视看片app提供海量高清电影在线观看和超清综艺播放内容，基础观影完全免费。同时我们也提供VIP会员服务，可解锁4K蓝光画质、离线缓存、多端同步等高级功能，会员价格实惠，性价比极高。',
  },
  {
    q: '高清电影在线观看对网络有什么要求？',
    a: '91影视看片app采用智能码率自适应技术，1080P高清在线播放推荐4Mbps以上带宽，4K蓝光影视资源推荐20Mbps以上。即使在弱网环境下，播放引擎也会自动调整画质，确保不缓冲高清播放体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91影视看片app全面支持iOS、Android手机和平板、Windows/Mac电脑以及主流智能电视和投影设备。一个账号全平台通用，观影记录、收藏与播放进度自动同步，随时随地畅享高清影视大全。',
  },
  {
    q: '片源更新频率如何？',
    a: '91影视看片app的影视高清片源每日更新，热门电影和电视剧集通常在院线/首播后24小时内上线高清版本。综艺节目实现同步更新，纪录片和经典影片也会定期扩充。我们拥有专业的内容运营团队，确保高清影视大全始终保持最新最全。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">关于91影视看片app的常见疑问解答</p>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                <span className="text-primary-600 mr-2">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                <span className="text-accent-600 mr-2 font-semibold">A:</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}